import {i18n} from "translate/i18n";

export const newTable = [
    [
        {
            col: 0,
            row: 0,
            type: "table_header",
            unit: null,
            unit_convert: null,
            value: ''
        },
        {
            col: 0,
            row: 0,
            type: "table_header",
            unit: null,
            unit_convert: null,
            value: ''
        },
        {
            col: 0,
            row: 0,
            type: "table_header",
            unit: null,
            unit_convert: null,
            value: ''
        },
        {
            col: 0,
            row: 0,
            type: "table_subheader",
            unit: null,
            unit_convert: null,
            value: ''
        },
        {
            col: 0,
            row: 0,
            type: "table_subheader",
            unit: null,
            unit_convert: null,
            value: ''
        },
        {
            col: 0,
            row: 0,
            type: "table_subheader",
            unit: null,
            unit_convert: null,
            value: ''
        },
        {
            col: 0,
            row: 0,
            type: "table_row",
            unit: "",
            unit_convert: null,
            value: "",
        },
        {
            col: 0,
            row: 0,
            type: "table_row",
            unit: "",
            unit_convert: null,
            value: "",
        },
        {
            col: 0,
            row: 0,
            type: "table_row",
            unit: "",
            unit_convert: null,
            value: "",
        }
    ]
]



export const newHeaderTable = [
    [
        {
            col: 0,
            row: 0,
            type: "table_header",
            unit: null,
            unit_convert: null,
            value: ''
        },
        {
            col: 0,
            row: 0,
            type: "table_header",
            unit: null,
            unit_convert: null,
            value: ''
        },
        {
            col: 0,
            row: 0,
            type: "table_header",
            unit: null,
            unit_convert: null,
            value: ''
        }
    ],
    [
        {
            col: 0,
            row: 0,
            type: "table_subheader",
            unit: null,
            unit_convert: null,
            value: ''
        },
        {
            col: 0,
            row: 0,
            type: "table_subheader",
            unit: null,
            unit_convert: null,
            value: ''
        },
        {
            col: 0,
            row: 0,
            type: "table_subheader",
            unit: null,
            unit_convert: null,
            value: ''
        }

    ]
]

export const newRowsTable = [
    [
        {
            col: 0,
            row: 0,
            type: "table_row",
            unit: "",
            unit_convert: null,
            value: "",
            block_column: 0,
        },
        {
            col: 0,
            row: 0,
            type: "table_row",
            unit: "",
            unit_convert: null,
            value: "",
            block_column: 0,
        },
        {
            col: 0,
            row: 0,
            type: "table_row",
            unit: "",
            unit_convert: null,
            value: "",
            block_column: 0,
        }

    ]
]

export function bouncer(arr) {
    return arr.filter(function (val) {
        return Boolean(val);
    });
}

export function compare(a,b) {
    if (a.created_at < b.created_at)
        return 1;
    if (a.created_at > b.created_at)
        return -1;
    return 0;
}

export function groupBy (array, key) {
    return array.reduce((acc, item) => ({
            ...acc,
            [item[key]]: [...(acc[item[key]] ?? []), item],
        }),
    {})
}

export const allUnits = [
    {label: i18n.t('units.texto'), value: i18n.t('units.texto')},
    {label: i18n.t('units.horas'), value: i18n.t('units.horas')},
    {label: i18n.t('units.taxa'), value: i18n.t('units.taxa')},
    {label: 'média', value: 'média'},
    {label: i18n.t('units.numero_total'), value: i18n.t('units.numero_total')},
    {label: 'mil', value: 'mil'},
    {label: 'ML', value: 'ML'},
    {label: 'mg/L', value: 'mg/L'},
    {label: 'm³', value: 'm³'},
    {label: 'm³/t', value: 'm³/t'},
    {label: 'tCO₂e', value: 'tCO₂e'},
    {label: 'tCO₂e/t', value: 'tCO₂e/t'},
    {label: 'tCO₂e/R$', value: 'tCO₂e/R$'},
    {label: i18n.t('units.dolares'), value: i18n.t('units.dolares')},
    {label: i18n.t('units.reais'), value: i18n.t('units.reais')},
    {label: '%', value: '%'},
    {label: 'ha', value: 'ha'},
    {label: 'km²', value: 'km²'},
    {label: 'GJ', value: 'GJ'},
    {label: 'GJ/t', value: 'GJ/t'},
    {label: 'MWh', value: 'MWh'},
    {label: 'MWm', value: 'MWm'},
    {label: 't', value: 't'},
    {label: 'mg/L', value: 'mg/L'},
    {label: 'KG', value: 'KG'},
    {label: 'kg/t', value: 'kg/t'},
    {label: 'ac', value: 'ac'}
]
